import Image from 'next/image'
import VideoPlayer from '../VideoPlayer/VideoPlayer'
import style from '../../styles/components/story/story'

const Hero = ({ story }) => {
  return (
    <>
      <div className='hero'>
        {story?.videoFile ? (
          <VideoPlayer poster={story.thumbnail.url} video={story.videoFile} title={story.title} label='Hero Video' />
        ) : (
          <Image src={story.heroImage?.url} width={1200} height={675} alt={story.title} />
        )}
      </div>
      <style jsx>{style}</style>
    </>
  )
}

export default Hero
